import { useCallback, useEffect, useMemo, useState } from 'react'
import { Box, Stack } from '@ui'
import { useDevice } from 'hooks/useDevice'
import { MediaPreview } from 'routes/EditSpaceMetadata/components/MediaDisplay/MediaDisplay'
import { MediaThumb } from 'routes/EditSpaceMetadata/components/MediaThumbs/MediaThumb'
import { MediaThumbContainer } from 'routes/EditSpaceMetadata/components/MediaThumbs/MediaThumbs'
import { MediaFormValue } from 'routes/EditSpaceMetadata/schema/spaceMetadata.schema'

type Props = {
    media: MediaFormValue[]
    fallbackImageSrc?: string
}

export const TownMedia = (props: Props) => {
    const { media } = props

    const [selectedId, setSelectedId] = useState<string | undefined>(() => media?.[0]?.key ?? '')

    const onSelectItem = useCallback((fieldId: string) => {
        setSelectedId(fieldId)
    }, [])

    const selectedMedia = useMemo(() => {
        const found = media.find((item) => item.key === selectedId)
        return found
    }, [media, selectedId])

    const firstMediaKey = media?.[0]?.key ?? ''
    useEffect(() => {
        // Always select the first media item when media array changes
        setSelectedId(firstMediaKey)
    }, [firstMediaKey])

    const { isTouch } = useDevice()

    return (
        <Stack
            horizontal={!isTouch}
            gap="md"
            aspectRatio={!isTouch ? '16/9' : media.length > 1 ? '1/1' : '16/9'}
            overflow="hidden"
        >
            <MediaPreview selectedMedia={selectedMedia} fallbackImageSrc={props.fallbackImageSrc} />
            {media.length > 1 && (
                <MediaThumbContainer>
                    {media.map((item, idx) => (
                        <Box key={item.key}>
                            <MediaThumb
                                media={item}
                                isSelected={selectedId === item.key}
                                index={idx}
                                fieldId={item.key}
                                onSelectItem={onSelectItem}
                            />
                        </Box>
                    ))}
                </MediaThumbContainer>
            )}
        </Stack>
    )
}
